import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const resetPasswordGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const cpf = sessionStorage.getItem('recovery_cpf');
  const token = sessionStorage.getItem('recovery_password_token');

  if (!cpf || !token) {
    return router.createUrlTree(['/forgot-password']);
  }

  return true;
};
